import {FormField} from '../../../types/form-builder.types';
import {Input} from '@shondalai/ui-commons';

interface AddressFieldProps {
  field: FormField;
  value: any;
  onChange: (value: any) => void;
}

export function AddressField({ field, value, onChange }: AddressFieldProps) {
  const config = field.config;
  const disabled = (config as any).disabled;

  // Ensure value is always an object, even if null or undefined
  const addressValue = value || {};

  const handleChange = (fieldName: string, fieldValue: string) => {
    onChange({
      ...addressValue,
      [fieldName]: fieldValue
    });
  };

  return (
    <div className="easyforms-address-field space-y-3">
      <div>
        <label className="text-sm font-medium mb-1 block">Street Address</label>
        <Input
          value={addressValue.street || ''}
          onChange={(e) => handleChange('street', e.target.value)}
          placeholder="123 Main St"
          disabled={disabled}
        />
      </div>

      <div>
        <label className="text-sm font-medium mb-1 block">Address Line 2</label>
        <Input
          value={addressValue.street2 || ''}
          onChange={(e) => handleChange('street2', e.target.value)}
          placeholder="Apt, Suite, Unit, etc. (optional)"
          disabled={disabled}
        />
      </div>

      <div className="grid grid-cols-2 gap-3">
        <div>
          <label className="text-sm font-medium mb-1 block">City</label>
          <Input
            value={addressValue.city || ''}
            onChange={(e) => handleChange('city', e.target.value)}
            placeholder="City"
            disabled={disabled}
          />
        </div>

        <div>
          <label className="text-sm font-medium mb-1 block">State/Province</label>
          <Input
            value={addressValue.state || ''}
            onChange={(e) => handleChange('state', e.target.value)}
            placeholder="State"
            disabled={disabled}
          />
        </div>
      </div>

      <div className="grid grid-cols-2 gap-3">
        <div>
          <label className="text-sm font-medium mb-1 block">Postal Code</label>
          <Input
            value={addressValue.postal || ''}
            onChange={(e) => handleChange('postal', e.target.value)}
            placeholder="12345"
            disabled={disabled}
          />
        </div>

        <div>
          <label className="text-sm font-medium mb-1 block">Country</label>
          <Input
            value={addressValue.country || ''}
            onChange={(e) => handleChange('country', e.target.value)}
            placeholder="Country"
            disabled={disabled}
          />
        </div>
      </div>

      {config.helpText && (
        <p className="text-xs text-muted-foreground mt-2">{config.helpText}</p>
      )}
    </div>
  );
}


